export default __webpack_public_path__ + "static/media/5.9ec739b2.jpg";